import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Check } from "lucide-react";
import { api, fmtDate, fmtINR } from "@/lib/api";
import { track } from "@/components/common/Analytics";

export default function BookingConfirmation() {
  const [params] = useSearchParams();
  const id = params.get("id");
  const [booking, setBooking] = useState(null);

  useEffect(() => {
    if (!id) return;
    api.get(`/bookings/${id}`).then(({ data }) => {
      setBooking(data);
      // Purchase event — fire once per confirmation page load.
      if (!window.__vyg_purchase_logged || window.__vyg_purchase_logged !== data.id) {
        window.__vyg_purchase_logged = data.id;
        track("purchase", {
          transaction_id: data.id,
          value: data.quote?.total || data.total || 0,
          currency: "INR",
          content_type: "stay",
          content_ids: [data.slug].filter(Boolean),
          content_name: data.property_name,
          num_items: data.guests,
        });
      }
    });
  }, [id]);

  return (
    <div data-testid="booking-confirmation" className="mx-auto max-w-2xl px-4 py-20 text-center sm:px-6">
      <Helmet><title>Booking confirmed · Vyagram</title></Helmet>
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-forest text-parchment">
        <Check size={28} />
      </div>
      <p className="vyg-eyebrow mt-6">Confirmed</p>
      <h1 className="mt-3 font-display text-4xl sm:text-5xl">Your stay is on.</h1>
      {booking ? (
        <>
          <p className="editorial-body mt-4">A confirmation has been sent to {booking.guest_email}. Our team will reach out with arrival details shortly.</p>
          <div className="mx-auto mt-8 max-w-md rounded-2xl border border-forest/15 bg-white p-6 text-left shadow-card">
            <p className="font-display text-xl">{booking.property_name}</p>
            <div className="mt-3 grid grid-cols-2 gap-3 text-sm text-noir/80">
              <div><p className="text-[11px] uppercase tracking-wider text-amber">Check-in</p><p>{fmtDate(booking.start_date)}</p></div>
              <div><p className="text-[11px] uppercase tracking-wider text-amber">Check-out</p><p>{fmtDate(booking.end_date)}</p></div>
              <div><p className="text-[11px] uppercase tracking-wider text-amber">Guests</p><p>{booking.guests}</p></div>
              <div><p className="text-[11px] uppercase tracking-wider text-amber">Total paid</p><p>{fmtINR(booking.quote?.total)}</p></div>
            </div>
            <p className="mt-4 font-mono text-xs text-noir/60">Reference · {booking.id}</p>
          </div>
        </>
      ) : (
        <p className="editorial-body mt-4">Finalising your reservation…</p>
      )}
      <Link to="/" className="vyg-cta-ghost mt-10 inline-flex" data-testid="confirmation-home-cta">Back to home</Link>
    </div>
  );
}
